/* eslint-disable max-nested-callbacks */
import React, { useEffect, useState } from 'react';
import './index.scss';
import { tools } from 'newcar-ui/output/cjs/utils';
import { appMethods } from 'newcar-ui/output/cjs/appMethods';
import Toast from 'antd-mobile/lib/toast';
import 'antd-mobile/lib/toast/style/index.css';
const type = appMethods.getAppType();
let App = () => {
  /** 是否是小程序渠道打开 */
  const [isMiniprogram, setIsMiniprogram] = useState(false);

  useEffect(() => {
    if (tools.getUrlParam('channel') === 'miniprogram') {
      setIsMiniprogram(true);
    }
    appMethods
      .loadAPPSDK()
      .then(() => {
        tools.live(
          document.getElementById('announceBox'),
          'a',
          'click',
          function (target, event) {
            event.preventDefault();
            const ua = navigator.userAgent.toLocaleLowerCase();
            const isIos = ua.indexOf('iphone') > -1;
            const isWbQiche = ua.indexOf('wubaqiche') > -1;
            if (isIos && isWbQiche) {
              // 五八汽车ios端临时修改跳转
              handleASwitch(target);
            } else {
              let href = target.getAttribute('href');
              const className = target.getAttribute('class');
              if (type == '58app' || type == '58town') {
                if (className == 'downloadFileBtn') {
                  // 下载按钮
                  window.XINCHEAPP.invoke(
                    'save_images',
                    {
                      images: [href],
                    },
                    function (state) {
                      if (state == 0) {
                        Toast.info('保存成功');
                      } else {
                        Toast.info('保存失败');
                      }
                    },
                  );
                } else {
                  if (href == 'sharedInformation') {
                    href = handleH5SwitchUrl(href);
                  } else if (href.indexOf('#') > -1) {
                    window.location.href = href;
                    return;
                  }
                  // window.location.href = href;
                  appMethods.goto(href);
                }
              }
            }
          },
        );
      })
      .catch(() => {
        tools.live(
          document.getElementById('announceBox'),
          'a',
          'click',
          function (target, event) {
            /** 如果是小程序打开的隐私协议需要判断是否是第三方链接，
             *  如果是新车链接（域名在小程序白名单内的）/ 执行返回或者其他的操作增加属性data-newcarurl=1 执行默认的逻辑，
             *  否则不允许点击
             * */
            const isNewcarUrl = target.getAttribute('data-newcarurl');
            if (
              !isNewcarUrl &&
              tools.getUrlParam('channel') === 'miniprogram'
            ) {
              event.preventDefault();
            } else {
              event.preventDefault();
              handleASwitch(target);
            }
          },
        );
      });
  }, []);

  const handleASwitch = (target) => {
    let href = target.getAttribute('href');
    const newHref = handleH5SwitchUrl(href);
    window.location.href = newHref;
  };
  const handleH5SwitchUrl = (href) => {
    let newHref = href;
    if (newHref === 'sharedInformation') {
      const hostName = window.location.hostname;
      // 兜底为m的隐私协议列表页面
      newHref =
        hostName === 'appsm.58che.com'
          ? `//${hostName}/58/sharedInformation.html`
          : `//m.58che.com/light/privacy/sharedInformation/`;
      // 如果是小程序投放的连接会携带channel参数
      if (tools.getUrlParam('channel') === 'miniprogram') {
        newHref += `?channel=${tools.getUrlParam('channel')}`;
      }
    }
    return newHref;
  };
  return (
    <>
      {!tools.is58App() && !isMiniprogram && (
        <header className='topdiv orange noRightPart'>
          <a
            className='returnDealer icoBg'
            data-newcarurl='1'
            href='javascript:history.go(-1);'
          >
            返回
          </a>
          <h1 className='brandName'>
            <a href='javascript:;'>58车隐私政策</a>
          </h1>
          <a href='//m.58che.com/' data-newcarurl='1' className='logo'></a>
        </header>
      )}
      <section className='announceBox' id='announceBox'>
        <div className='anunit'>
          <h3>
            【特别提示】请您仔细阅读我们的《58车隐私政策》（尤其是加粗划线的内容）并确定了解我们对您个人信息的处理规则。阅读过程中，如您有任何疑问，可及时与我们联系（联系方式以隐私政策里约定的为准）。如您不同意协议中的任何条款，您应立即停止访问或登录58车网站及软件。
          </h3>
          <h2 className='bt'>58车隐私政策</h2>
          <p>版本更新日期：2022年9月22日</p>
          <p>版本生效日期：2022年9月29日</p>
          <h2>引言</h2>
          <p>《58车隐私政策》将帮助您了解以下内容： </p>
          <p>1、我们如何收集和使用您的个人信息</p>
          <p>2、我们如何使用 Cookie 和同类技术</p>
          <p>3、我们如何共享、转让、公开披露您的个人信息</p>
          <p>4、我们如何保护您的个人信息</p>
          <p>5、您的权利</p>
          <p>6、我们如何处理未成年人的个人信息</p>
          <p>7、本隐私政策如何更新</p>
          <p>8、如何联系我们 </p>
          <p>
            58车平台（以下亦称“我们”）深知个人信息对您的重要性，我们尊重并保护所有使用58车平台服务的用户的个人信息，并会尽全力保护您的个人信息安全可靠。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
            请在使用我们的产品（或服务）前，仔细阅读并了解本《隐私政策》（下称“本隐私政策”）。{' '}
          </p>
          <p>
            如您对本隐私政策有任何疑问或您在使用我们提供的服务时个人信息受到了侵扰，您可以发送邮件至58chepm@58.com或拨打4008-585858电话咨询，我们设立了个人信息保护专职部门，将尽快给予您答复。
          </p>

          <h2>目录：</h2>
          <p>
            <a href='#a'>一、我们处理个人信息的总原则</a>
          </p>
          <p>
            <a href='#b'>二、本隐私政策的适用范围</a>
          </p>
          <p>
            <a href='#c'>三、我们如何收集和使用您的个人信息</a>{' '}
          </p>
          <p>
            <a href='#d'>四、我们如何使用 Cookie 和同类技术</a>{' '}
          </p>
          <p>
            <a href='#e'>五、我们如何共享、转让、公开披露您的个人信息</a>
          </p>
          <p>
            <a href='#f'>六、我们如何存储及保护您的个人信息</a>
          </p>
          <p>
            <a href='#g'>七、您管理个人信息的权利</a>{' '}
          </p>
          <p>
            <a href='#h'>八、我们如何处理未成年人的个人信息</a>
          </p>
          <p>
            <a href='#i'>九、本隐私政策的更新和通知</a>
          </p>
          <p>
            <a href='#j'>十、如何联系我们</a>
          </p>
          <p>
            <a href='#k'>十一、争议解决</a>
          </p>

          <h2 id='a'>一、我们处理个人信息的总原则</h2>
          <p>
            通常，我们会基于本隐私政策提示的功能收集您的个人信息。某些情况下，如果涉及其他信息的收集我们会单独向您出示个人信息保护说明条款。在处理您的个人信息方面，我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则。
          </p>
          <h2 id='b'>二、定义及本隐私政策的适用范围</h2>
          <p>
            1、58车平台:包括58车网站www.58che.com、58车无线站点wap.58che.com,m.58che.com、58车移动应用软件58车APP。
          </p>
          <p>
            2、58车服务提供者：
            <b>58车平台的运营主体为北京五八汽车科技有限公司。</b>
          </p>
          <p>
            3、个人信息（出自于GB/T 35273-2020《信息安全技术
            个人信息安全规范》）：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，如姓名、出生日期、身份证件号码、个人生物识别信息、住址、通信通讯联系方式、通信记录和内容、账号密码、财产信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息这类信息。我们实际具体收集的个人信息种类以下文描述为准。
          </p>
          <p>
            4、个人敏感信息（出自于GB/T 35273-2020《信息安全技术
            个人信息安全规范》）：一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇的个人信息。我们实际具体收集的个人敏感信息种类以下文描述为准，我们会以加粗并加下划线标红的方式提示您注意阅读。相比其他个人信息，个人敏感信息可能对您的个人权益影响更大。我们在此善意的提醒您需在谨慎考虑后再向我们提供您的个人敏感信息。
          </p>
          <p>
            5、匿名化：是指通过对个人信息的技术处理，使得个人信息主体无法被识别或者关联，且处理后的信息不能被复原的过程。
          </p>
          <p>
            6、个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为时期保持不可被检索、访问的状态。
          </p>
          <p>7、设备：是指用于访问我们的产品和/或服务的手机装置。</p>
          <p>8、儿童：指不满14周岁的未成年人。</p>
          <p>
            9、本隐私政策的适用范围：本隐私政策适用于您使用58车平台的产品和/或服务时。
          </p>
          <p>
            10、您同意隐私政策仅代表您已了解应用提供的功能，以及功能运行所需的必要个人信息，并不代表您已同意我们可以收集非必要个人信息，非必要个人信息会根据您使用过程中的授权情况单独征求您的同意。
          </p>
          <p>
            11、如您拒绝本隐私政策，您仍能够在无注册/登录状态下浏览58车平台的内容，但是您无法使用询底价、发布评论等基本功能。您仍可以在后续使用服务过程中单独授权同意本隐私政策。
          </p>

          <h2 id='c'>三、我们如何收集和使用您的个人信息</h2>
          <p>
            根据《常见类型移动互联网应用程序必要个人信息范围规定》，58车APP属于“浏览器类”，基本功能服务为“浏览互联网信息资源”，无须个人信息，即可使用基本功能服务。同时，58车平台也为您提供询底价、发布评论等的附加功能，我们仅会出于本隐私政策所述的以下目的在正当必要的原则下收集和使用您的个人信息，如果超出以下目的收集和使用您的个人信息，我们会单独说明并获得您的同意。
          </p>
          <p>
            根据上述法律法规的规定及58车平台实际可能为您提供的服务类型，在您使用我们的产品/服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务；为实现向您提供我们产品及/或服务的附加功能，您可选择授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及/或服务的基本功能。
          </p>
          <h3>（一）帮助您成为我们的注册\登录用户</h3>
          <p>
            <b>1、您自行注册成为58车网站的用户</b>
          </p>
          <p>（1）必需信息、非必需信息</p>
          <p>
            您在浏览58车APP上的车辆信息时，无需注册登录即可以访客的身份浏览使用，此时您的浏览信息我们将不会进行记录。当您希望使用58车平台提供的其他服务时，首先需要成为我们的注册用户。当您在58车PC端注册成为我们的用户时，我们将收集您填写的
            <b>用户名、密码、手机号</b>
            ，并通过您填写的验证码验证您的真实性；当您在58车APP注册成为我们的用户时，我们将收集您填写的
            <b>手机号、密码</b>
            ，并通过短信验证码的方式来验证您的身份是否真实有效。此类信息属于该功能的必需信息，若您不向我们提供，将无法完成注册。您注册完成后，可以使用注册时使用的手机号、密码或短信验证码登录58车平台。
          </p>
          <p>（2）使用的第三方SDK</p>
          <p>
            我们会接入第三方SDK，包括移动一键登录SDK、电信一键登录SDK、联通一键登录SDK（Android端、iOS端）为您实现手机号一键登录【58车平台】的功能，将由其收集您的IP地址、SIM
            卡IMSI、手机号码，此类信息属于该功能的必需信息，如您拒绝提供，将无法实现一键登录的功能。
          </p>
          <p>
            <b>2、您通过第三方授权登录为58车网站的用户</b>
          </p>
          <p>（1）必需信息、非必需信息</p>
          <p>
            您使用第三方帐号（微信、微博、QQ）登录58车网站时，可选择授权58车网站在符合相关法律法规要求的前提下读取并获得您
            <b style={{ textDecoration: 'underline' }}>
              在该第三方平台上登记、公布、记录的公开信息（包括昵称、头像）
            </b>
            。此类信息属于该功能的必需信息，若您不提供，将无法通过第三方授权登录为58车网站的用户。
          </p>
          <p>
            58车网站需要您授权从第三方获取上述信息是为了记住您作为58车网站用户的登录身份，以向您提供更优质的产品和/或服务。我们仅会在您的授权同意的范围内收集并使用您的个人信息。
          </p>
          <p>
            您提供的上述信息，将在您使用58车服务期间持续授权我们使用。
            <b>在您注销账号时，我们将停止使用并删除上述信息。</b>
          </p>
          <p>（2）使用的第三方SDK</p>
          <p>
            我们会接入第三方SDK（包括微信SDK、QQ分享SDK、微博SDK）为您实现第三方授权登录【58车平台】的功能，将由其收集您的设备标识信息，此类信息属于该功能的必需信息，如您拒绝提供，将无法实现第三方授权登录的功能。
          </p>
          <h3>（二）向您提供我们的产品或服务</h3>
          <p>1、咨询底价、预约试驾、置换卖车咨询功能</p>
          <p>（1）必需信息、非必需信息</p>
          <p>
            58车平台最主要的功能就是为用户提供咨询底价功能、预约试驾功能及置换卖车咨询功能，您可以根据您的需要选择意向车型、车辆上牌城市。当您使用询底价功能时，我们会收集您的个人信息，包括
            <b style={{ textDecoration: 'underline' }}>
              姓名、手机号码、上牌城市以及您选择咨询的车辆信息，其中姓名可以填写您拟定的昵称
            </b>
            。此类信息为您自己主动填写的信息，收集是为了方便我们联系您为您提供服务，可以更快捷的与您意向的车型进行匹配。
          </p>
          <p>（2）调取的设备权限</p>
          <p>
            <b>位置权限</b>
            ，为向您提供您所在地区的经销商及车辆价格信息，我们需要获取您的位置信息。若您拒绝提供位置权限，我们将无法为您推荐您所在地区的经销商及车辆价格信息。
            <b>拨打电话权限（仅andorid）</b>
            ，当您选择咨询经销商时，我们需要获取您的拨打电话权限，以便您能够与您选择的经销商取得联系。若您拒绝提供拨打电话权限，您将无法在58车平台上点击拨打经销商的电话。
          </p>
          <p>
            <b>2、互动发布评论、口碑、打分、关注、收藏功能</b>
          </p>
          <p>（1）必需信息、非必需信息</p>
          <p>
            当您需对您感兴趣的车辆、文章等内容进行互动发布评论、口碑或打分、关注、收藏时，您需要进行实名认证，因此您需要先登录58车平台账号，您登录账号后方可使用这些功能；当您使用互动发布评论、口碑、打分的功能时，我们将收集您发布的内容，并在审核后向58车平台的其他用户展示您发布的内容；当您使用关注和收藏功能时，我们将收集您关注和收藏的车辆信息，并在页面中为您展示。
          </p>
          <p>
            <b>3、搜索/订阅功能</b>
          </p>
          <p>
            当使用58车平台提供的搜索功能时，包括买车服务中的儿童座椅查找器、购车费用计算器，我们会收集您查询的关键字信息以及您在使用58车平台服务时所浏览或要求的其他信息和内容详情，以便为您提供您希望搜索和查找的内容。为了给您带来更便捷的搜索服务并不断完善58车平台产品和/或服务。该等关键词信息通常无法单独识别您的个人身份，不属于您的个人信息，不在本隐私政策的限制范围内。只有当您的搜索关键词信息与您的其他信息有联结并可识别您的个人身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本隐私政策对其进行处理与保护。
          </p>
          <p>
            <b>4、客户服务</b>
          </p>
          <p>
            当您向58车平台投诉、申诉或进行咨询时，为了方便与您联系或帮助您解决问题，我们可能需要您提供
            <b style={{ textDecoration: 'underline' }}>
              姓名、手机号码、电子邮件
            </b>
            信息。如您拒绝提供上述信息，可能部分功能无法使用，同时无法向您及时反馈申诉或咨询结果。
          </p>
          <p>
            <b>5、定向推送</b>
          </p>
          <p>（1）必需信息、非必需信息</p>
          <p>
            我们会基于收集的信息，对您的偏好、习惯、位置作特征分析和用户画像，以便为您提供更适合的定制化服务，例如向您展现或推荐相关程度更高（而非普遍推送）的订阅信息、信息流或者广告/推广信息结果。为此，我们需要收集的信息包括您的设备信息、
            <b style={{ textDecoration: 'underline' }}>日志信息、浏览记录</b>
            。如您不希望获得我们的定向推送服务，58车APP端，您可以通过“关于”-“隐私管理”中进行设置。
          </p>
          <p>
            <b>6、营销活动</b>
          </p>
          <p>
            我们将会不时举办线上或线下的营销活动，包括邀请用户奖励红包、赠送实体物品活动。在此类营销活动中，我们可能需要用户提供
            <b style={{ textDecoration: 'underline' }}>
              个人信息（如手机号、邮编、地址信息）、参与营销活动的证明信息（如参与购车活动，需提供购车发票及购车车型）
            </b>
            ，以便我们能够给用户发放奖励或寄送礼品。在涉及58车平台向您支付费用的情况下，我们可能需要收集您的身份信息
            <b style={{ textDecoration: 'underline' }}>（姓名、身份证号）</b>
            用于代缴税款。具体请以我们在营销活动中的说明为准。
          </p>
          <p>
            <b>7、关于设备权限的说明</b>
          </p>
          <p>
            我们在上述服务中获取您关于设备权限的同意，我们将在您首次下载APP或者具体使用到上述所列功能时逐一以弹窗的形式提前向您提示，您可以根据您的需要进行选择。
            <b>
              请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理
            </b>
            。
          </p>
          <p>
            <b>8、其他服务</b>
          </p>
          <p>
            1）<b>基于二次验证您账号身份的场景</b>
            ，我们有时会收集您的常用手机品牌。当58车网站发现您的账号信息疑似出现登录异常时，我们会向您进行问题调研，结合您填写答案对您的账号进行匹配验证，以确保您账号的使用安全。除此之外，58车网站不对上述收集的信息进行其他形式的使用。
          </p>
          <p>
            2）<b>安全保障功能:</b>
            除上述58车网站向您提供的产品和服务外，我们可能会收集您的
            <b style={{ textDecoration: 'underline' }}>
              MAC地址信息、应用列表信息、imei或oaid、Android Id 、CPU ID
              序列号、OpenUUId (iOS
              )、网络地址、硬件序列号、IMSI、加速度传感器、重力传感器、陀螺仪传感器、旋转矢量传感器、光线传感器、线性加速器、磁场传感器、压力传感器、相对湿度传感器、环境温度传感器
            </b>
            ，该信息的收集用于保障您的58车网站账号安全、防盗号、信息安全的功能，我们不会对MAC信息作其他用途使用。
          </p>
          <p>
            3）我们可能为了提供服务及改进服务质量的合理需要而收集您的其他信息，包括您与我们的客户服务团队联系时所提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息。与此同时，为提高您使用58车平台提供的服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，我们可能会通过了解一些您的网络使用习惯、您常用的软件信息手段来判断您账户的风险，并可能会记录一些我们认为有风险的URL。
          </p>
          <p>
            <b>
              在不透露单个用户隐私资料的前提下，我们有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。我们可能会对网络服务使用情况进行统计。同时，我们可能会与公众分享这些统计信息，以展示我们服务的整体使用趋势。这些统计信息不包含您的任何身份识别信息。
            </b>
          </p>
          <h3>（三）征得授权同意的例外</h3>
          <p>
            根据相关法律法规的规定，在以下情形中，我们可以在不征得您的授权同意的情况下收集、使用一些必要的个人信息：
          </p>
          <p>1、与国家安全、国防安全直接相关的；</p>
          <p>2、与公共安全、公共卫生、重大公共利益直接相关的；</p>
          <p>3、与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
          <p>
            4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
          </p>
          <p>5、所收集的个人信息是您自行向社会公众公开的；</p>
          <p>
            6、从合法公开披露的信息中收集到您的个人信息，如从合法的新闻报道、政府信息公开等渠道；
          </p>
          <p>7、根据您的要求签订和履行合同所必需的；</p>
          <p>8、法律法规规定的其他情形。</p>
          <p>
            <b>
              您知悉并认可：我们通过广告或其他方式向您提供链接，使您可以接入第三方服务或网站。您使用该等第三方的服务时，须受该第三方的服务条款及隐私政策约束，我们提示您需要仔细阅读其政策。本协议仅适用于我们提供的服务器所收集的信息，并不适用于第三方提供的服务或第三方的信息使用的规则，我们对第三方使用由您自行提供的信息不承担责任。
            </b>
          </p>
          <h2 id='d'>四、我们如何使用 Cookie 和同类技术 </h2>
          <p>
            为使您获得更轻松的访问体验，您访问58车平台相关网站或使用58车平台提供的服务时，我们可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie，Flash
            Cookie，或您的浏览器提供的其他本地存储（统称“Cookie”）。
          </p>
          <p>
            网页上常会包含一些电子图象（称为“单像素” GIF 文件或 “网络
            beacon”），使用网络beacon可以帮助网站计算浏览网页的用户或访问某些cookie，我们会通过网络beacon收集您浏览网页活动的信息，例如您访问的页面地址、您先前访问的援引页面的位址、您停留在页面的时间、您的浏览环境以及显示设定。
          </p>
          <p>
            58车网站
            <b>
              可能使用您在58车网站浏览的行为数据，根据您的兴趣喜好，在您浏览网站时有可能展现与您兴趣相关的信息或内容，这个过程包括以下几个方面：
            </b>
          </p>
          <p>
            <b>
              1)兴趣数据的收集：我们通过您在58车浏览过的内容，使用Cookie收集并保存您的行为数据。
            </b>
          </p>
          <p>
            <b>
              2)根据您的浏览行为数据，获取您的兴趣分类。例如您最近两天寻找北京某车系信息，我们会了解您的兴趣是北京的该车系车辆。
            </b>
          </p>
          <p>
            <b>
              我们不会将上述技术收集的信息用于本隐私政策所述目的之外的任何用途。请您理解，我们的某些服务只能通过使用“Cookie”才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以在相关的页面修改对Cookie的接受程度，但这一举动在某些情况下可能会影响您安全访问58车网站和使用58车平台提供的服务。
            </b>
          </p>
          <h2 id='e'>五、我们如何共享、转让、公开披露您的个人信息 </h2>
          <h3>（一）共享</h3>
          <p>
            我们不会与58车以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：
          </p>
          <p>
            <b>1、在获得明确同意的情况下共享：</b>
            获得您的明确同意后，我们会与其他方共享您的个人信息。
          </p>
          <p>
            <b>2、根据法律法规的规定和行政、司法机构的要求</b>
            ：我们可能会根据法律法规规定，或按政府主管部门的强制性要求，向上述监管部门共享您的个人信息。
          </p>
          <p>
            <b>
              3、与我们的关联公司共享：您的个人信息可能会与58车平台的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。关联公司指58车平台运营主体直接或间接控制的法人实体及其分支机构，与58车平台运营主体直接或间接共同受控于同一实际控制人的法人实体及其分支机构；控制、受控指：通过协议或股权控制或受控。为实现推广效果最大化，您授权同意58车平台将您在58车平台所上传发布的信息内容同步展示在58同城平台（包括58同城网站www.58.com、58同城无线站点wap.58.com,m.58.com、58同城移动应用软件58同城APPAPP）。关联公司收集的信息详见
            </b>
            <a href='sharedInformation' data-newcarurl='1'>
              《58车与第三方共享个人信息清单》
            </a>
          </p>
          <p>
            <b>
              4、与授权合作伙伴共享：仅为实现本隐私政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验
            </b>
            。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。
          </p>
          <p>目前，我们的授权合作伙伴包括以下2大类型：</p>
          <p>
            <b>1）广告、分析服务类的授权合作伙伴</b>
            。我们不会将您的个人信息与提供广告、咨询类服务商与关联公司共享，除非您主动授权我们提供。但我们可能会将经处理无法识别您的身份且接收方无法复原的信息，例如经匿名化处理的用户画像，与广告或咨询类服务商或广告主共享，以帮助其在不识别您个人的前提下，提升广告有效触达率，以及分析我们的产品和服务使用情况。
          </p>
          <p>
            <b>
              2）服务提供商和其他合作伙伴，如汽车经销商、厂商、汽车金融消费贷款公司、贷款中介公司、汽车资讯及服务平台
            </b>
            。您在使用我们的具体服务时，我们在获得您的同意后将您自主填写的信息，我们将您填写的信息提供给您想要联系的服务提供商或其他合作伙伴。
          </p>
          <p>
            <b>
              例如，您想要了解某款车系车型的底价或预约试驾或进行车辆置换时，您自主填写并提交的联系方式，我们会在您提交并获得您的同意后，将您的联系方式提供给您想咨询的车主、车商或合作平台及该平台合作的您感兴趣的车系的经销商，
            </b>
            目前我们的合作方明细如下：北京优捷信息科技有限公司（易车运营主体）、北京百度网讯科技有限公司（有驾平台运营主体）、北京有竹居网络技术有限公司（懂车帝平台运营主体）、广州太平洋电脑信息咨询有限公司（太平洋汽车运营主体）、天津车之家软件有限公司（汽车之家运营主体）。。
          </p>
          <p>
            <b>例如，您想要了解某款车是否可以办理贷款及相关贷款政策时</b>
            ，您自主填写并提交的联系方式，我们会在您提交后，提供给平台合作的汽车消费金融贷款公司、贷款中介公司。
          </p>
          <p>
            <b>
              3）为保障58车平台稳定运行或实现相关功能，我们还可能会接入由第三方提供的软件开发包（SDK）实现前述目的。我们对接入的相关第三方SDK同时在
              <a href='sharedInformation' data-newcarurl='1'>
                《58车与第三方共享个人信息清单》
              </a>
              中列明。您可以通过目录中提供的链接或者路径查看第三方的数据使用和保护规则。请注意，第三方SDK可能由于版本升级、策略调整等原因导致其个人信息处理类型发生变化，请以其公示的官方说明为准。
            </b>
          </p>
          <p>
            <b>
              对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
            </b>
          </p>
          <p>5、以学术研究或公共利益为目的，且无害于您的重大利益；</p>
          <p>
            6、如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；
          </p>
          <p>
            7、只有共享您的信息，才能提供您需要的服务或处理您与他人的纠纷或争议。例如您在58车上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，58车会视情况向该用户提供其交易对方的联络方式必要信息，以促成交易的完成或纠纷的解决；
          </p>
          <h3>（二）转让</h3>
          <p>
            我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
          </p>
          <p>
            <b>1、在获取明确同意的情况下转让：</b>
            获得您的明确同意后，我们会向其他方转让您的个人信息；
          </p>
          <p>
            <b>2、在涉及合并、收购或破产清算时，如涉及到个人信息转让</b>
            ，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
          </p>
          <h3>（三）公开披露</h3>
          <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
          <p>
            <b>1、获得您明确同意后；</b>
          </p>
          <p>
            <b>2、基于法律的披露：</b>
            在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会对上述监管部门披露您的个人信息。
          </p>
          <p>
            <b>
              我们知晓对外共享、转让、公开披露个人信息所承担的相应法律责任。我们承诺按照本条款的要求共享、转让、公开披露您的个人信息，按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认、弹窗、提示等形式征得您的同意或确认第三方已经征得您的同意。
            </b>
          </p>
          <p>
            <b>
              因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请通过本隐私政策文首处提供的联系方式操作。
            </b>
          </p>

          <h2 id='f'>六、我们如何存储及保护您的个人信息 </h2>
          <h3>（一）信息存储</h3>
          <p>
            58车收集的有关您的信息和资料将保存在58车及（或）其关联公司的服务器上，
            <b>
              这些信息和资料全部储存在中国境内。目前，58车的产品和服务不会涉及到数据的跨境传输，如果我们的产品\服务发生变更，涉及数据的跨境传输
            </b>
            ，我们会单独向您以弹窗或邮件的方式告知您数据出境的目的、接收方等，并征得您的授权同意，我们会确保数据接收方有充足的数据保护能力来保护您的个人信息。
          </p>
          <p>
            <b>
              我们仅在您使用我们的服务期间和法律法规要求的最短时限内保留您的个人信息，在仅浏览功能下所收集的个人信息如浏览记录、IP
              信息，我们的存储期限不会超过1个月。对于超出期限的个人信息，我们会立即删除或做匿名化处理。
            </b>
          </p>
          <h3>（二）信息保护</h3>
          <p>
            为保障您的信息安全，我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。
          </p>
          <p>
            <b>1、数据加密：</b>
            我们对于用户的用户名、手机号、注册邮箱、qq号进行加密存储，保证用户基本信息不会被恶意获取；
          </p>
          <p>
            <b>2、身份鉴别：</b>
            我们通过校验账号密码或者账号绑定手机验证码，进行用户身份合法性鉴别，防止非经授权的介入；
          </p>
          <p>
            <b>3、访问控制：</b>
            我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。58车用户在进行身份鉴别后，才能查询并管理用户信息和资源，未经过身份鉴别，不能管理用户资源；
          </p>
          <p>
            <b>4、安全审计：</b>
            我们有时会接入风控平台或认证平台，对一些场景或行为进行监测。如通过流量分析，完成账号异常登陆、注册等异常行为的监控。
          </p>
          <p>
            58车会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，58车将尽力做到使您的信息不被泄漏、毁损或丢失。
          </p>
          <p>
            <b>5、账号保护：</b>
            您的账户均有安全保护功能，请妥善保管您的账户及密码信息。58车将通过向其它服务器备份、对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您理解，由于技术的限制以及可能存在的各种恶意手段，即便竭尽所能加强安全措施，在信息网络上也不存在“完善的安全措施”。如因您自己的原因导致账户及密码信息泄露而造成的任何法律后果需由您本人负责。
          </p>
          <p>
            <b>
              在使用58车平台服务进行网上交易时，如您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息（例如联系人、联络方式），请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息已经被泄露或者存在被泄露的可能，且有可能会危及您注册获得的58车账户安全，或者给您造成其他的损失的，请您务必在第一时间根据本隐私政策提到的联系方式与我们取得联系，以便我们采取相应措施维护您的58车账户安全，防止损失的发生或者进一步扩大。
            </b>
          </p>
          <p>
            6、互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
          </p>
          <h2 id='g'>七、您管理个人信息的权利 </h2>
          <p>
            58车非常重视您对个人信息的关注，并尽全力保护您对于自己个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：{' '}
          </p>
          <h3>（一）个人信息的查询、更正</h3>
          <p>
            您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：
          </p>
          <p>PC端：</p>
          <p>
            1、您的个人资料信息：您可以通过58车首页上方“个人中心”—“个人资料”，访问、更正您的账户信息；
          </p>
          <p>
            2、您的账号安全信息：您可以通过58车首页上方“个人中心”—“账号绑定”，访问、更正您的认证手机、认证邮箱、登录密码、QQ账号、微博、微信账号的信息；
          </p>
          <h3>（二）个人信息的删除</h3>
          <p>
            您有权删除您在58车平台上的个人信息，您可以通过58汽车APP首页下方“关于”—“清空缓存”的路径操作删除您的个人信息。同时，在以下情形中，您可以向我们提出删除个人信息的请求：
          </p>
          <p>1）如果我们处理个人信息的行为违反法律法规；</p>
          <p>2）如果我们收集、使用您的个人信息，却未征得您的同意；</p>
          <p>3）如果我们处理个人信息的行为违反了与您的约定；</p>
          <p>4）如果我们终止服务及运营。</p>
          <h3>（三）改变您授权同意的范围或撤回您的授权</h3>
          <p>
            您可以通过删除信息、关闭设备功能、在58车网站或软件中进行隐私设置等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。
          </p>
          <h3>（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</h3>
          <p>
            根据法律规定，在以下情形中，我们共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
          </p>
          <p>1）与国家安全、国防安全直接相关的；</p>
          <p>2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
          <p>3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
          <p>
            4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
          </p>
          <p>5）个人信息主体自行向社会公众公开的个人信息；</p>
          <p>
            6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
          </p>
          <h3>（五）注销账户</h3>
          <p>
            您可以在我们的产品或服务中直接申请注销账户。关于您注销账户的方式以及您应满足的条件，请详见“注销账户”页面。
            您注销账户后，我们将停止为您提供产品与/或服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。如果您对注销账号有疑问的，可以发邮件至58chepm@58.com，我们会有专门的人员进行回复反馈。
          </p>
          <h3>（六）响应您的上述请求</h3>
          <p>
            为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
          </p>

          <h2 id='h'>八、我们如何处理未成年人的个人信息</h2>
          <p>
            <b>
              1、58车主要为汽车资讯及信息服务类平台，我们的服务主要面向成年人（原则上18周岁以上为成年人，16周岁以上且以自己的劳动收入为主要生活来源的我们亦视为成年人）。若您是未成年人，在使用我们的产品和/或服务前，您应在监护人的陪同下阅读本隐私政策，并应确保已征得您的监护人同意后使用我们的服务并向我们提供您的信息。
              我们会根据国家相关法律法规的规定着重保护未成年人的个人信息。
            </b>
          </p>
          <p>
            <b>
              2、如您不满16周岁或者年满16周岁但无法以自己的劳动收入作为主要生活来源，则不符合58同城APP对注册用户的要求，58同城APP不收集您的个人信息。若您是未成年人，在使用3、如果您不是以自己的劳动收入为主要来源的十六周岁以上的未成年人，您仍然需要在监护人同意及监督下使用我们的产品。如您的监护人不同意您使用我们的服务时，请您立即终止使用我们的服务。如果我们发现任何未成年人的信息，我们会即时删除处理并终止为您提供服务。
            </b>
          </p>
          <h2 id='i'>九、本隐私政策的更新和通知</h2>
          <p>
            我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本隐私政策所做的任何变更。
          </p>
          <p>
            <b>
              对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，
              我们会通过电子邮件发送通知，说明隐私政策的具体变更内容）。
            </b>
          </p>
          <p>本隐私政策所指的重大变更包括但不限于：</p>
          <p>
            1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
          </p>
          <p>
            2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
          </p>
          <p>3、个人信息共享、转让或公开披露的主要对象发生变化；</p>
          <p>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
          <p>
            5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
          </p>
          <p>6、个人信息安全影响评估报告表明存在高风险时。</p>
          <p>
            <b>
              您除了在58车平台进行注册时，可以查看到最新版本的隐私政策外，PC端，您可以点击58车注册页面的隐私政策链接看到我们最新版本的《58车隐私政策》；APP端，您可以在“我的”-“关于58车”查看最新版本的《58车隐私政策》。
            </b>
          </p>

          <h2 id='j'>十、如何联系我们</h2>
          <p>
            如您对本隐私政策有任何疑问或您在使用我们提供的服务时个人信息受到了侵扰，您可以通过4008-585858电话与我们联系、或
            <b>发送邮件至58chepm@58.com咨询</b>
            ，我们设立了个人信息保护专职部门，将尽快给予您答复。一般情况下，我们将在十五天内（国家法定节假日顺延）回复。我们的注册地址：北京市海淀区学清路甲18号中关村东升科技园学院园四层401室；常用办公地址：北京市酒仙桥北路甲10号院101号楼。
          </p>

          <h2 id='k'>十一、争议解决</h2>
          <p>
            1、如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信办及工商等监管部门进行反馈，其中，中央网信办违法和不良信息举报中心的官方网址为：
            <a href='http://www.12377.cn'>http://www.12377.cn</a>
          </p>
          <p>
            2、因本隐私政策以及我们处理您个人信息事宜引起的任何争议，
            <b>任何一方可向被告所在地的法院进行诉讼。</b>
          </p>
        </div>
        {!isMiniprogram && (
          <p style={{ textAlign: 'center' }}>
            <a
              className='downloadFileBtn'
              href='https://icon.xgo-img.com.cn/topic/22092114/M58.jpg'
            >
              下载文档
            </a>
            <br />
          </p>
        )}
      </section>
    </>
  );
};

export default App;
